import axios from 'axios';
import { throttleAdapterEnhancer } from 'axios-extensions';

const VueAxios = {
    install(Vue, options) {
        const axiosInstance = axios.create({
            baseURL: options.baseUrl,
            adapter: throttleAdapterEnhancer(axios.defaults.adapter)
        });

        axiosInstance.interceptors.request.use(function (config) {
            config.headers.common.Authorization =
                'bearer ' + localStorage.getItem('accessToken');
            return config;
        });

        Vue.prototype.$http = axiosInstance;
    }
};

export default VueAxios;
